import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import InternalUsersData from "../pages/InternalUsersData";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";
import PerformersActivity from "./PerformersActivity";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  const navigate = useNavigate();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function InternalUsers() {
  const { userData } = useContext(UserDataContext);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTabIU", newValue);
  };

  useEffect(() => {
    if (userData && userData.permId !== "1" && userData.permId !== "3") {
      navigate("/nopermission");
    }
  }, [userData]);
  /*
  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabIU");
    if (savedTab) {
      setValue(parseInt(savedTab, 10));
    }
  }, []);
*/
  return (
    <div>
      <VN userData={userData} />
      {/*
      <Box sx={{ width: "100%" }}>
       */}

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <ThemeProvider theme={theme}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="underMenu"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="Osoby zarządzające" />
            <Tab label="Aktywność" />
          </Tabs>
        </ThemeProvider>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Row>
          <InternalUsersData />
        </Row>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Row>{/* <PerformersActivity perm="1" /> */}</Row>
      </CustomTabPanel>
    </div>
  );
}
